import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Form, Input, Col } from "antd";

function EmailField({
  data,
  index,
  // default
  className,
}) {
  const childClassNames = classNames(
    "custom-form-column",
    "email-input-column",
    className,
  );
  const { t } = useTranslation();

  return (
    data && (
      <Col
        key={data?.name + index + "-col"}
        md={data?.col || 24}
        xs={24}
        offset={data?.offset || null}
        className={childClassNames}
      >
        <Form.Item
          key={data?.name + index + "-item"}
          label={data?.displayLabel ? data?.label : data?.label}
          name={data?.name}
          className={data?.name + "-wrapper"}
          initialValue={data?.value}
          rules={[
            {
              type: "email",
              message: t("errors.entryInvalidEmail"),
              validateTrigger: "onSubmit",
            },
            {
              required: data?.required || false,
              message: t("inputs.mandatoryField"),
              validateTrigger: "onSubmit",
            },
          ]}
        >
          <Input
            placeholder={
              data?.placeholder !== undefined ? data?.placeholder : data?.label
            }
          />
        </Form.Item>
      </Col>
    )
  );
}

EmailField.defaultProps = {
  index: 1,
};

EmailField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(EmailField);
